import React, { useState, useEffect, useContext } from 'react';
import ResizeDetector from "react-resize-detector";
import { IoIosEye, IoIosEyeOff } from 'react-icons/io';
import { useDispatch } from 'react-redux'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useNavigate, useLocation, useParams} from 'react-router-dom';
import { signup, SignupGoogle, signupFacebook } from '../../actions/auth_actions';
import Swal from 'sweetalert'
import styles from '../../assets/css/rstyling.module.css'
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Input } from 'reactstrap';
import {useGoogleLogin} from '@react-oauth/google';
import { FcGoogle } from 'react-icons/fc';
import {IoLogoFacebook} from 'react-icons/io';
import {LoginSocialFacebook} from 'reactjs-social-login';
import { userDetailsContext } from '../../UserDetailsProvider';
import SecureLS from 'secure-ls';
import axios from 'axios'
import { getLoggedInUser } from '../../actions/auth_actions';


const Choice = () => {

   let {search} = useLocation()
    const ls = new SecureLS()
    const dispatch = useDispatch()
    const history = useNavigate();
    
    const {userDetails, setUserDetails} = useContext(userDetailsContext);
// if users signup with google

const query = new URLSearchParams(window.decodeURIComponent(search));
const code = query.get('code')

const  handleGoogleLoginSuccess= (tokenResponse)=>{
                 const accessToken =  tokenResponse.access_token;
                
                 let referredBy=''
                 if(query.get('code')){
                    referredBy = query.get('code')
                 }
                
                 dispatch(SignupGoogle(accessToken, referredBy))

                 
                     
                .then(response=>{
                    
                    setUserDetails(response.payload.content)
                    ls.set('accessToken', { accessToken: response.payload.content.accessToken, role: response.payload.content.role });
                  
                   axios.defaults.headers.common['Authorization'] = `Bearer ${response.payload.content.accessToken}`;
            dispatch(getLoggedInUser())
            .then(response1 => {
                    
                ls.set('accessUser', { user: response1.payload.content });
                if (ls.get('accessToken').role) {
                    if (ls.get('accessToken').role === 3) {
                        
                    //history('/login')
                    history('/phone')} } })
                 
                    Swal({
                        title: "Signed Up",
                        text: "Signup with Google was successful" ,
                       
                        icon: 'success'
                    })
                 })
                 
                    
                    .catch(err => {
                
                        if (err.response.data.name === "Duplication Error") {
                            Swal({
                                title: "Info",
                                text: "User already exists.",
                                icon: 'info'
                            });
                        } else {
                            Swal({
                                title: err.response ? err.response.data.name : "Error",
                                text: err.response ? err.response.data.content : "Please try again!",
                                icon: 'error'
                            });
                        }
        
                    })
   

}

useEffect(()=>{
   
        // Check if the user is accessing the app from an in-app browser
        const isInAppBrowser = /Instagram/.test(navigator.userAgent);
    
        if (isInAppBrowser) {
          alert('For the best experience, please open this link in Chrome browser.');
        }
      
if(query.get('code')){
    console.log('came here in code')
}

},[])

    const Login = useGoogleLogin({onSuccess: handleGoogleLoginSuccess});
   
    // if users signup with facebook
    const FacebookLogin=(response)=>{
       
        let referredBy=''
        if(query.get('code')){
           referredBy = query.get('code')
        }


        const accessToken = response.data.accessToken
        dispatch(signupFacebook(accessToken, referredBy))
    
        .then(response=>{
            setUserDetails(response.payload.content)
            ls.set('accessToken', { accessToken: response.payload.content.accessToken, role: response.payload.content.role });
           
           axios.defaults.headers.common['Authorization'] = `Bearer ${response.payload.content.accessToken}`;
    dispatch(getLoggedInUser())
    .then(response1 => {
            
        ls.set('accessUser', { user: response1.payload.content });
        if (ls.get('accessToken').role) {
            if (ls.get('accessToken').role === 3) {
            //history('/login')
            history('/phone')} } })
            Swal({
                title: "Signed Up",
                text: "Signup with Facebook was successful" ,
               
                icon: 'success'
            })
         }
            )
            .catch(err => {
        
                if (err.response.data.name === "Duplication Error") {
                    Swal({
                        title: "Info",
                        text: "User already exists.",
                        icon: 'info'
                    });
                } else {
                    Swal({
                        title: err.response ? err.response.data.name : "Error",
                        text: err.response ? err.response.data.content : "Please try again!",
                        icon: 'error'
                    });
                }

            })
    
    }
    

    return (
        <ResizeDetector
            handleWidth
            render={({ width, height }) => (

                <div className="_signup_">
                    
                    <div className="d-flex">
                        <div className="col-lg-8 col-12">

                            {/* Logo */}
                            <div className="py-2">
                                <a href="/">
                                    <img src={require('../../assets/utils/images/logo.png')} alt="logo" width='135' />
                                </a>
                            </div>

                            <div className="container">
                                
                                < div className="row justify-content-center align-items-center">
                                    <div className="col-12">

                                        <div className="mb-5 text-center">
                                            <h4 className="text-dark mb-2 mt-2" style={{ fontWeight: '500' }} >Let's get started</h4>
                                            <p style={{ fontSize: '1rem' }}>Create your account</p>
                                        </div>

                                         <div className="row"> 

                                                <div className='col-12 text-center'>
                                                               
                                                                <div className="mb-2 d-inline-block" >
                                                                    
                                                                    
                                                                    <button onClick={() => Login()}  className='btn-hover-shine btn text-dark btn-block py-2 bg-light btn-outline-secondary ' ><FcGoogle size={18} className='mx-3' />Sign Up with Google</button> 
                                                                     
                                                                     <LoginSocialFacebook
                                                                   
                                                                    appId='1666970400472102'
                                                                   
                                                                   
                                                                    onResolve={(response)=>{
                                                                    FacebookLogin(response)
                                                                    }}
                                                                    onReject={(error)=>{ console.log(error)
                                                                    }}
                                                                    
                                                                    >
                                                                        <button className='btn-hover-shine btn text-dark btn-block py-2 bg-light btn-outline-secondary my-2' ><IoLogoFacebook size={19} className='mx-2' style={{color:'#4963ab'}}
                                                                        
                                                                    
                                                                
                                                                        />Sign Up with Facebook</button>
                                                                    </LoginSocialFacebook>
                                                                    <a href={code && code!=='' && code!=undefined ? `/signup?code=${code}`: `/signup`} className={`${styles.bg_blue} btn-hover-shine btn text-light btn-block py-2`} style={{ backgroundColor: '#006FA7' }} >
                                                                     Sign Up with Email
                                                                    </a>
                                                                    <div className="mt-3">
                                                                    <label style={{ fontSize: '0.95rem', fontWeight: '400', color: '#888' }}>
                                                                        Already have an account? &nbsp;
                                                                        <a href="/login" style={{ color: '#006FA7' }}>
                                                                            Sign in
                                                                        </a>
                                                                    </label>

                                                                </div> 
                                                                </div>
                                                                </div>   
                                                                
                                                                
                                                                       
                                                                
                                                            </div>
                                                        </div>

                                                        

                                                    
                                                
                                        

                                
                                        

                                         



                                    
                                    
                                </div>
                                
                            </div>
                           

                        </div>
                        
                        
                            
                            
                        <div className="col-lg-4 d-lg-block d-none side_bg px-0">
                            {/* Gradient Overlay */}
                            <div className="grad_overlay"></div>

                            <div className="text-center px-3">
                                <div className="d-flex justify-content-center align-items-center h-100">
                                    <div className="col-12">
                                        <h3 className="mb-4" style={{ color: "#eee", fontWeight: '700', lineHeight: '2.65rem', letterSpacing: '2px' }}>Signup now</h3>
                                        <h4 style={{ color: "#eee", fontWeight: '500', lineHeight: '2.65rem', letterSpacing: '2px' }}>
                                            Genuinely Connecting Consumers to Brands.
                                            Influence change in the world with your Voice!
                                        </h4>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div >

                </div >
            )}
        />

    )

}

export default Choice;